import Icons from '@datacloud-incubation/frontend-icons-module';
import { ROUTER_PATH } from '@constants/routerItems.constant';
import { tokenService } from '@core/services/Token.service';
import type { TSettingsMenuItem } from '@components/Settings/models/settings.model';
import type { NavigateFunction } from 'react-router';

const getSettingsMenu = (navigate: NavigateFunction): TSettingsMenuItem[] => {
  return [
    {
      label: 'Profile',
      Icon: Icons.IconDbUser,
      onClick: () => {
        void navigate(ROUTER_PATH.viewProfile);
      }
    },
    {
      label: 'Log Out',
      Icon: Icons.IconLogOut,
      onClick: () => {
        tokenService.removeTokens();
      }
    }
  ];
};

export { getSettingsMenu };
